// extracted by mini-css-extract-plugin
export default {"wrapper":"XWOM4trZ5WFfn9XhiLH5","text":"reDA3jWcnrtjJ4YKOUfs","logos":"j0_8RZGMb0eofDN9VKbw"};